import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './tags.style.scss';
import { EMPTY_STRING, KEY_ENTER } from '../../../constants/constants';
/**
 * Class representing tags component.
 * @extends Component
 * */
class Tags extends Component {

  state = {
    inputTag: EMPTY_STRING,
    isAddButtonDisabled: true
  };

  /**
   * Calls tag addition if tag is not part of the tags array.
   * */
  handleAddition = () => {
    const { onAddition, tags } = this.props;
    const { inputTag } = this.state;
    if (!inputTag) {
      return;
    }
    const tagFound = tags.find(tag => tag === inputTag);
    if (!tagFound) {
      onAddition(inputTag);
      this.clearInputTag();
    }
  };

  /**
   * Sets input tag in state at change event.
   * @param {object} event - The input tag change event.
   * */
  handleInputTagChange = (event) => {
    const { target: { value } } = event;
    this.setState({ inputTag: value, isAddButtonDisabled: value === EMPTY_STRING });
  };

  /**
   * Calls tag addition when uses hits enter key in input field.
   * @param {object} event - The input tag key down event.
   * */
  handleInputTagKeyDown = (event) => {
    if (event.which === KEY_ENTER) {
      this.handleAddition();
    }
  }

  /**
   * Calls tag delete and clears tag input.
   * @param {object} tag - The tag to delete.
   * */
  handleDelete = tag => () => {
    const { onDelete } = this.props;
    onDelete(tag);
  };

  /**
   * Clears tag input text.
   * */
  clearInputTag = () => {
    this.setState({ inputTag: EMPTY_STRING, isAddButtonDisabled: true });
  };

  render() {
    const { tags } = this.props;
    const { inputTag, isAddButtonDisabled } = this.state;
    return (
      <div className="clearfix">
        <div className="input-group mb-3 tags">
          <input
            aria-describedby="basic-addon2"
            aria-label="type tag"
            className="form-control"
            onChange={this.handleInputTagChange}
            onKeyDown={this.handleInputTagKeyDown}
            placeholder="type tag"
            type="text"
            value={inputTag}
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-secondary"
              id="addTagBtn"
              disabled={isAddButtonDisabled}
              onClick={this.handleAddition}
              type="button"
            >Add
            </button>
          </div>
        </div>
        {tags.map(tag => (
          <div className="btn btn-outline-secondary tag" key={tag}>
            {tag} <span className="badge badge-light" onClick={this.handleDelete(tag)}>x</span>
          </div>
        ))}
      </div>
    );
  }
}
export default Tags;

Tags.propTypes = {
  onAddition: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
};
Tags.defaultProps = {
  tags: []
};



// WEBPACK FOOTER //
// ./src/common/components/tags/tags.component.js